export enum pageStates {
  payment = "payment",
  createAccount = "createAccount",
  orderConfirmation = "orderConfirmation",
  email = "email",
  reviewOrder = "reviewOrder",
}

export enum enhancedCartTypes {
  billingAddress = "billing_address",
  shippingAddress = "shipping_address",
  cardDetails = "add_payment_info",
  reviewOrder = "review_order",
}

export enum layoutStates {
  purchase = "purchase",
  editShipping = "editShipping",
  editPayment = "editPayment",
  editPayPalShippingAddress = "editPayPalShippingAddress",
}

export enum emailPageStates {
  enterEmail = "enterEmail",
  alreadyAnAccount = "alreadyAnAccount",
  addedEmail = "addedEmail",
  hideEmail = "hideEmail",
}

export enum terms {
  monthToMonth = "monthToMonth",
  year = "year",
  years = "years",
}

export enum productTypes {
  safeConsumer = "safeConsumer",
  webroot = "webroot",
}

export enum adjustments {
  Tax = "Tax",
  UsedCreditBalance = "UsedCreditBalance",
  RemainingCreditBalance = "RemainingCreditBalance",
  PromoCodeAmt = "PromoCodeAmt",
  PromoCodePct = "PromoCodePct",
  PriorSubscriptionCredit = "PriorSubscriptionCredit",
  OneTimeAmt = "OneTimeAmt",
  BonusMonthsPromo = "BonusMonthsPromo",
  Discounts = "Discounts",
  TrialDaysRemaining = "TrialDaysRemaining",
  LicenseDaysRemaining = "LicenseDaysRemaining",
}

export enum promoCodeStates {
  enter = "Enter",
  applied = "Applied",
}

export enum purchaseErrors {
  CCAddress = "CCAddress",
  CCTransaction = "CCTransaction",
  InvalidUpgradePath = "InvalidUpgradePath",
  SubscriptionExpired = "SubscriptionExpired",
  InvalidRemainingDays = "InvalidRemainingDays",
  CartItemRatePlanIdInvalid = "CartItemRatePlanIdInvalid",
  SmbUserIneligible = "SmbUserIneligible",
  AlreadyHaveOneAllstateSku = "AlreadyHaveOneAllstateSku",
  AlreadyHasVPNPSku = "AlreadyHasVPNPSku",
  PurchaseFailureError = "PurchaseFailureError",
  NotEligibleForRenewal = "NotEligibleForRenewal",
  UnderMaintenance = "UnderMaintenance",
  OwnedByBestBuy = "OwnedByBestBuy",
  UpgradeOnRetailRenewalNotAllowed = "UpgradeOnRetailRenewalNotAllowed",
  InvalidPromotionCode = "InvalidPromotionCode",
  InvalidSubscription = "InvalidSubscription",
  InvalidComputer = "InvalidComputer",
  SmbComputerIneligible = "SmbComputerIneligible",
  UpgradeDuringFruWindowNotAllowed = "UpgradeDuringFruWindowNotAllowed",
  FruInFruWindowNotAllowed = "FruInFruWindowNotAllowed",
  HasOutstandingInvoices = "HasOutstandingInvoices",
  RetailUpgradeNotAllowed = "RetailUpgradeNotAllowed",
  BadLicenseKey = "BadLicenseKey",
  WTPUpgradeByComputerIdNotAllowed = "WTPUpgradeByComputerIdNotAllowed",
  UserCannotHaveMultipleTrialItems = "UserCannotHaveMultipleTrialItems",
  HasTrialOrPreviousSubscription = "HasTrialOrPreviousSubscription",
  CannotUpgradeOrRenewActiveOptOutTrial = "CannotUpgradeOrRenewActiveOptOutTrial",
  CartHasTrialAndProductFromSameFamily = "CartHasTrialAndProductFromSameFamily",
  TrialHasBuldledItems = "TrialHasBuldledItems",
}

export enum purchaseErrorsNotifications {
  CCAddress = "CreditCardAddressError",
  CCTransaction = "CreditCardDeclinedError",
  PurchaseFailureError = "ServerErrors",
}

export enum SafeProductNames {
  PersonalBasic = "PersonalBasic",
  PersonalPlus = "PersonalPlus",
  PersonalPrime = "PersonalPrime",
}

export enum paymentTypes {
  None = "None",
  CreditCard = "CreditCard",
  PayPal = "PayPal",
}

export enum openTextBrands {
  Carbonite = "Carbonite",
  Webroot = "Webroot",
}

export enum showKeycodeState {
  loading,
  success,
  failed,
}

export enum webrootTrialUnits {
  WSAV = 1,
  WSAI = 3,
  WSAC = 5,
}

export enum PlanetOTErrors {
  InvalidGuid = "InvalidGuid",
  GuidAlreadyUsed = "GuidAlreadyUsed",
  GuidExpired = "GuidExpired",
  EnrollmentGuidExpired = "EnrollmentGuidExpired", //Used during update shopping cart
}

export enum ProductCatalogPriceType {
  CatalogPrice = "catalogPrice",
  NewSubscriptionPrice = "newSubscriptionPrice",
}

export enum CastleErrors {
  TwoFactorDenied = "TwoFactorDenied",
}

//Putting back for now. TODO: ask why they were removed
export enum payPalGateways {
  CarbonitePayPalGateway = "Carbonite PayPal",
  WebrootPayPalGateway = "Webroot PayPal",
}

export enum emailValidationErrors {
  EmailInUseNoLoginLink = "ValidationError_EmailInUseNoLoginLink",
  EmailInUse = "ValidationError_EmailInUse",
  AolPurchaseError = "AolPurchaseError",
  IsAolAccount = "IsAolAccount",
}
